var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-0ab20457-ca67-40f5-9e57-e768a381620c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.42 25.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m.06,2.41c2.14,5.97,4.28,11.94,6.42,17.91,1.38-5.81,2.75-11.62,4.13-17.43.95,5.7,1.91,11.4,2.86,17.1,1.76-5.57,3.52-11.13,5.28-16.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.75,5.55c-.17-1.35-1.36-2.62-2.69-2.92s-2.72-.05-4.06.2c-1.52.28-3.2.67-4.04,1.96-.65.98-.63,2.24-.6,3.42.05,1.65.1,3.3.15,4.95.04,1.3.08,2.62.43,3.87s1.03,2.46,2.11,3.18c1.94,1.29,4.73.64,6.37-1.02s2.3-4.07,2.43-6.39-.1-4.92-.12-7.25Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.18,11.13c2.32.27,4.76.33,6.88-.66s3.77-3.29,3.33-5.58c-.12-.63-.41-1.25-.92-1.64-.56-.42-1.31-.5-2.01-.56-2.6-.23-5.74-.24-8.34-.47.27,6.06,0,12.36.28,18.42.05-.13.09-.25.14-.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.02,11.44c.63,3.18,1.48,6.32,2.54,9.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.73,20.59c-.13-5.67-.26-12.37-.39-18.04",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.6,2.55c-3.97,2.96-7.75,6.19-11.31,9.65,2.26.45,4.3,1.67,6.04,3.18s3.2,3.3,4.66,5.08",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.434fc9ea94288c33c665a0beccfe77a9.svg";
export { ForwardRef as ReactComponent };